


























































import { Vue, Component, Prop } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'

@Component({})
export default class AppHomepageFrame extends Vue {
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly organizationUrl!: string

  appsClick () {
    this.$emit('appsClick')
  }

  storeClick () {
    this.$emit('openStore')
  }

  get currentDay () {
    const today = new Date()
    return today.toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: '2-digit' })
  }

  time = ''

  created () {
    setInterval(this.currentTime, 1000)
  }

  currentTime () {
    this.time = new Date().toLocaleTimeString('it-IT')
  }
}
